import { APP_INITIALIZER } from '@angular/core';
import { ensureAnnouncekitBarHeightFallback } from './announcekit-bar-height';

export function announcekitBarHeightInit(): () => void {
  return () => {
    ensureAnnouncekitBarHeightFallback();
  };
}

export const announcekitBarHeightInitProvider = {
  provide: APP_INITIALIZER,
  useFactory: announcekitBarHeightInit,
  multi: true,
};
